document.addEventListener('DOMContentLoaded', () => {
  const animateNumber = (el) => {
    if (el.dataset.animated) return;
    el.dataset.animated = "true";

    const originalText = el.dataset.value;
    // Extract prefix, number (with commas), and suffix
    const match = originalText.match(/^([^0-9]*)([\d,]+)([^0-9]*)$/);
    if (!match) return; // If no match, do not animate

    const prefix = match[1];
    const numberStr = match[2].replace(/,/g, '');
    const suffix = match[3];
    
    const target = parseInt(numberStr, 10);
    if (isNaN(target)) return;

    const duration = 2000; // 2 seconds animation
    const start = performance.now();

    const update = (currentTime) => {
      const elapsed = currentTime - start;
      const progress = Math.min(elapsed / duration, 1);
      
      // easeOutQuart
      const ease = 1 - Math.pow(1 - progress, 4);
      const current = Math.floor(ease * target);
      
      el.textContent = prefix + current.toLocaleString('en-US') + suffix;
      
      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = originalText;
      }
    };
    
    // Start empty to prevent jumping from original
    el.textContent = prefix + "0" + suffix;
    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const numberElement = entry.target;
        animateNumber(numberElement);
        observer.unobserve(numberElement);
      }
    });
  }, {
    threshold: 0.1 // Trigger when 10% of the number element is visible
  });

  const numberElements = document.querySelectorAll('.custom-stats__number');
  numberElements.forEach(el => observer.observe(el));
});
